import { Map, List } from 'immutable';
import { ActionTypes, RAILCARD1617_CODE } from '../constants/AppConstants';
import BaseStore from './BaseStore';
import AccountRailcard from '../records/AccountRailcard';
import Railcard1617Form from '../records/search/Railcard1617Form';

class Railcard1617Store extends BaseStore {
    getInitialState() {
        return super.getInitialState().merge({
            checked: null,
            flashCheckbox: false,
            form: new Railcard1617Form({
                railcardNumber: '',
                firstName: '',
                lastName: '',
                syncKeyGo: false,
            }),
            guestRailcardErrors: new Map(),
            isRailcard1617Available: false,
            submitting: false,
            railcard: new AccountRailcard(),
            railcards: new List(),
            validation: new Map(),
            validationSuccess: false
        });
    }

    getActionHandlers() {
        return {
            [ActionTypes.LOGGED_OUT]: this.handleUserLoggedOut,
            [ActionTypes.RAILCARD1617_CHECKED]: this.handleChecked,
            [ActionTypes.RAILCARD1617_FLASH_CHECKBOX]: this.handleFlashCheckbox,
            [ActionTypes.RAILCARD1617_FORM_CHANGED]: this.handleFormChanged,
            [ActionTypes.RAILCARD1617_LOADED]: this.handleLoaded,
            [ActionTypes.RAILCARD1617_LOAD_STARTED]: this.handleLoadStarted,
            [ActionTypes.RAILCARD1617_REMOVE]: this.handleRemove,
            [ActionTypes.RAILCARD1617_RESET_VALIDATION]: this.handleResetValidation,
            [ActionTypes.RAILCARD1617_VALIDATION_STARTED]: this.handleValidationStarted,
            [ActionTypes.RAILCARD1617_VALIDATION_COMPLETED]: this.handleValidationCompleted,
            [ActionTypes.RAILCARD1617_VALIDATION_FAILED]: this.handleValidationFailed,
        };
    }

    getForm() {
        return this.get('form');
    }

    getRailcard() {
        return this.get('railcard');
    }

    getGuestRailcardErrors() {
        return this.get('guestRailcardErrors');
    }

    hasRailcard1617Saver() {
        return !!(this.get('railcard') && this.get('railcard').railcardCode && this.get('railcard').railcardCode === RAILCARD1617_CODE);
    }

    handleChecked({ checked }) {
        this.setState(this.state.merge({ checked }));
    }

    handleFlashCheckbox({ flashCheckbox }) {
        this.setState(this.state.merge({ flashCheckbox }));
    }

    handleFormChanged({ field, value }) {
        const form = this.get('form').set(field, value);

        const validation = this.get('validation').merge(form.getValidationSummary());
        this.setState(this.state.merge({ form, validation }));
    }

    handleLoaded({ railcards }) {
        // Pick the railcard with the latest expiry date
        const railcard = railcards.sortBy(
            rc => rc.getMaximumValidDate().unix()
        ).last();

        // Do not override the existing railcard from the state with a null from the request
        if (railcard) {
            this.setState(this.state.merge({
                isRailcard1617Available: true,
                railcard,
                railcards,
            }));
        }
    }

    handleLoadStarted() {
        this.setState(this.state.merge({
            'isRailcard1617Available': false,
        }));
    }

    handleUserLoggedOut() {
        this.setState(this.getInitialState());
    }

    handleRemove() {
        this.setState(this.state.set('railcard', new AccountRailcard()));
    }

    handleValidationCompleted({ railcardNumber, firstName, lastName, expiryDate }) {
        this.setState(this.state.merge({
            checked: true,
            isRailcard1617Available: true,
            railcard: AccountRailcard.fromJSON({
                expiryDate,
                cardholderName: `${firstName} ${lastName}`,
                isGuest: true,
                railcardCode: RAILCARD1617_CODE,
                railcardNumber,
                state: 'ACCEPTED',
            }),
            submitting: false,
            validationSuccess: true
        }));
    }

    handleValidationStarted() {
        this.setState(this.state.merge({
            guestRailcardErrors: new Map(),
            isRailcard1617Available: false,
            submitting: true,
            validationSuccess: false
        }));
    }

    handleValidationFailed({ message }) {
        this.setState(this.state.merge({
            checked: false,
            guestRailcardErrors: new Map({ invalid: message || "booking.railcard1617.errors.unknown" }),
            isRailcard1617Available: false,
            railcard: new AccountRailcard(),
            submitting: false,
            validationSuccess: false
        }));
    }

    handleResetValidation() {
        this.setState(this.state.merge({ validationSuccess: false }));
    }
}

const storeInstance = new Railcard1617Store();

export default storeInstance;



// WEBPACK FOOTER //
// ./src/stores/Railcard1617Store.js